// Vendor
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

// Components
import Grid from 'src/components/atoms/Grid';
import DocumentLinkLoader from 'src/components/molecules/DocumentLinkLoader/DocumentListLoader';
import { InstructionLoader } from 'src/components/molecules/InstructionLoader';
import { ShowState } from 'src/components/molecules/ShowState';
import { DocumentLinkRow } from 'src/components/organisms/DocumentLinkRow';
import { DocumentLinkInstructions } from './DocumentLinkInstructions';
import { StyledGrid, StyledInstructionContainer } from './styles';

// Hooks
import useProperty from 'src/features/property/hooks/useProperty';

// Redux
import { selectors as propertySelectors } from 'src/features/property/propertySlice';

// Types
import { IProperty } from 'src/ts/interfaces';

const DocumentLinkList: React.FC = () => {
  const filter = 'status=ACTIVE,identity_verification_only_web_portal=disabled';
  const { onGetDocumentListProperties } = useProperty();

  const getPropertiesData = useSelector(propertySelectors.documentLinkListProperties.data);
  const getPropertiesIsIdle = useSelector(propertySelectors.documentLinkListProperties.isIdle);
  const getPropertiesIsLoading = useSelector(
    propertySelectors.documentLinkListProperties.isLoading
  );
  const getPropertiesError = useSelector(propertySelectors.documentLinkListProperties.error);
  const getPropertiesIsSuccess = useSelector(
    propertySelectors.documentLinkListProperties.isSuccess
  );

  useEffect(() => {
    onGetDocumentListProperties(0, 5, filter);
  }, [onGetDocumentListProperties, getPropertiesIsIdle, filter]);

  if (getPropertiesError) {
    return (
      <ShowState
        variant="error"
        type="information"
        buttonLabel="Please, try again"
        message="Something went wrong"
        onClick={() => window.location.reload()}
      />
    );
  }

  if (getPropertiesIsLoading) {
    return (
      <Grid justify="space-between">
        <DocumentLinkLoader />
        <InstructionLoader />
      </Grid>
    );
  }

  if (getPropertiesIsSuccess && !getPropertiesData?.length) {
    return (
      <ShowState message="There are no properties <br/> to show" type="property" variant="empty" />
    );
  }

  return (
    <>
      <Grid>
        <StyledGrid direction="column">
          {getPropertiesData?.map((property: IProperty) => {
            return (
              <DocumentLinkRow
                key={property.id}
                name={property.name}
                address={property.address}
                city={property.city}
                company_short_id={property.company_short_id}
                short_id={property.short_id}
                state={property.state}
                zip={property.zip}
                disable_dup_fd={property.disable_dup_fd}
                property_features={property.property_features}
              />
            );
          })}
        </StyledGrid>
        <StyledInstructionContainer>
          <DocumentLinkInstructions />
        </StyledInstructionContainer>
      </Grid>
    </>
  );
};
export default DocumentLinkList;
